// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class BasicEnrollmentDeactivateResponse {
    static getAttributeTypeMap() {
        return BasicEnrollmentDeactivateResponse.attributeTypeMap;
    }
}
BasicEnrollmentDeactivateResponse.discriminator = undefined;
BasicEnrollmentDeactivateResponse.additionalProperties = false;
BasicEnrollmentDeactivateResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=basicEnrollmentDeactivateResponse.js.map